import React from "react";
import MaintenanceImageArea from "./MaintenanceImageArea";
// import MaintenanceDocumentsArea from "../AddMaintenance/MaintenanceDocumentsArea";
import DocumentsArea from "components/Common/DocumentsArea/index";
import ImageGallery from "../../Common/ImageGallery";
import ImageSlider from "../../Common/ImageSlider";
import DocumentGallery from "../../Common/DocumentGallery";
import { Modal } from "reactstrap";
import { themeService } from "../../../theme/service/activeTheme.service";
import "components/Common/commonform.css";
export const DocumentImageSection = {
  loadDocumentImageArea: (
    { documentList, imageList, showImageSlider, showImageGallery, showDocuments, selectedImageIndex },
    { addMaintenanceStateHandler, addDocumentHandle, addSelectedImage, addSelectedDocument, deleteDocumentHandle, deleteImageHandle },
  ) => {
    return [
      {
        position: "body",
        sectionPosition: "start",
        sectionId: "MaintenanceFiles",
        customComp: [
          <div style={{ paddingInline: "20px" }}>
            <MaintenanceImageArea
              imagesList={imageList}
              addMaintenanceStateHandler={addMaintenanceStateHandler}
              allowDelete={true}
              onDeleteImage={(imageName, index) => {
                deleteImageHandle && deleteImageHandle(imageName, index);
              }}
            />
            {/* <MaintenanceDocumentsArea documentList={documentList} addDocument={() => addDocumentHandle({ showDocuments: true })} /> */}
            <DocumentsArea
              acctionBtn
              documentList={documentList}
              addDocument={() => addDocumentHandle({ showDocuments: true })}
              deleteDocument={deleteDocumentHandle}
            />

            <Modal
              contentClassName={themeService({ retro: "retroModal" })}
              isOpen={showDocuments}
              style={{ maxWidth: "80%", maxHeight: "auto" }}
            >
              <DocumentGallery
                handleSave={addSelectedDocument}
                handleCancel={() => addDocumentHandle({ showDocuments: false })}
                loadDocumentPath={"showAssetDocuments"}
                customFolder={"applicationresources"}
                uploadImageAllow
              />
            </Modal>

            <Modal
              contentClassName={themeService({ retro: "retroModal" })}
              isOpen={showImageGallery}
              style={{ maxWidth: "80%", maxHeight: "auto" }}
            >
              <ImageGallery
                handleSave={addSelectedImage}
                handleCancel={() => addMaintenanceStateHandler({ showImageGallery: false })}
                loadImgPath={""}
                customFolder={"applicationresources"}
                uploadImageAllow
              />
            </Modal>

            <ImageSlider
              imgSlider={showImageSlider}
              imageDirectory={"applicationresources"}
              images={imageList}
              initialIndex={selectedImageIndex}
              handleToggle={() => addMaintenanceStateHandler({ showImageSlider: false })}
            />
          </div>,
        ],
      },
    ];
  },
};



// WEBPACK FOOTER //
// ./src/components/Maintenance/AddMaintenanceV2/DocumentImageSection.js